module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aabdo1-b31adf72e5c6551eef90575de6b5ce0e.jpg";